<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .placeholder {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: utils.in_rem(12px);

    > span {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .padding {
    border: utils.in_rem(6px) solid transparent;
  }

  .list-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: utils.in_rem(8px);
  }
</style>

<script>
  import Avatar from "@sourcewhale/shared/svelte-design-system/components/atoms/Avatar.svelte";
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import Search from "@sourcewhale/shared/svelte-design-system/components/atoms/Search/Search.svelte";
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";

  export let placeholder = "";
  export let placeholderIcon = "";
  export let placeholderAvatar = "";
  export let showFilter = true; // search bar.
  export let items = null;
  export let selectedItem = ""; // bind to this.
  export let size = "large";

  $: loading = !items;

  $: selectedItemFull = loading
    ? {}
    : items.find((x) => x.id === selectedItem) || {};
  $: displayText = loading ? "" : selectedItemFull.label || placeholder;
  $: displayIcon = loading ? "" : selectedItemFull.icon || placeholderIcon;
  $: displayAvatar = loading
    ? ""
    : selectedItemFull.avatar || placeholderAvatar;

  let closeDropdown;
  let filterValue = "";
  let focusSearch;

  $: filteredItems = loading
    ? []
    : items.filter((x) =>
        x.label.toLowerCase().includes(filterValue.toLowerCase())
      );

  $: dropdownProps = {
    style: "width: 100%",
    kind: "input-field",
    size,
    disabled: loading,
  };
</script>

<Dropdown
  {...dropdownProps}
  bind:close={closeDropdown}
  onclick={() => {
    filterValue = "";
    if (focusSearch) focusSearch();
  }}
  {...$$restProps}
>
  <div slot="button" class="placeholder">
    {#if displayIcon}
      <div><Icon class={displayIcon} /></div>
    {:else if displayAvatar}
      <div><Avatar {...{ ...displayAvatar, size: "extra-small" }} /></div>
    {/if}
    <span>{displayText}</span>
  </div>
  <div slot="header">
    {#if showFilter}
      <Search bind:value={filterValue} bind:focus={focusSearch} />
      <div class="padding"></div>
    {/if}
  </div>
  {#each filteredItems as item}
    <ListItem
      icon={item.icon}
      src={item.src}
      onclick={() => {
        selectedItem = item.id;
        closeDropdown();
      }}
      selected={selectedItem === item.id}
    >
      <div class="list-row">
        {#if item.avatar}
          <Avatar {...{ ...item.avatar, size: "small" }} />
        {/if}
        {item.label}
      </div>
    </ListItem>
  {/each}
</Dropdown>
